module.exports = __webpack_public_path__ + "media/img/patterns/grid-vertical-btt-dark-52a7781bba4a8b5a02bc4921240a749b.png";